<template>
  <v-card :key="mode">
    <!-- navigation tabs -->
    <v-card class="d-flex justify-center align-center">
      <div>
        <v-tabs v-model="currentTab">
          <v-tab :disabled="mode !== 'new' ? true : false">Persona</v-tab>
          <v-tab :disabled="!object">Productor</v-tab>
          <v-tab :disabled="!object || $bRoot.auth.current_level > 2">
            Agentes
          </v-tab>
        </v-tabs>
      </div>
    </v-card>

    <!-- person search only for new registers -->
    <person
      v-if="currentTab === 0 && mode === 'new'"
      @itemSelected="personSelected($event)"
      :enableManual="false"
    ></person>

    <!-- producer data -->
    <v-card-text v-if="currentTab === 1 && object">
      <v-card>
        <v-card class="mb-2">
          <v-card-title>
            Persona
          </v-card-title>
          <v-card-text>
            <v-text-field
              disabled
              label="Nombre"
              id="person_name"
              v-model="object.person_name"
            ></v-text-field>
            <v-text-field
              disabled
              label="Identificación"
              id="person_identification"
              v-model="object.person_identification"
            ></v-text-field>
            <v-select
              :disabled="!editing"
              :items="categories"
              item-text="description"
              item-value="url"
              v-model="object.category"
              label="Categoria"
            ></v-select>
            <div class="d-flex align-center">
              <v-text-field
                disabled
                v-model="object.superior_person_name"
                label="Informar Agrupado En"
              >
                <v-icon
                  slot="append-outer"
                  :class="editing ? 'enabled-icon' : 'disabled-icon'"
                  v-show="editing"
                  @click="superiorClick"
                >
                  {{
                    !object.superior ? "mdi-magnify" : "mdi-trash-can-outline"
                  }}
                </v-icon>
              </v-text-field>
            </div>
          </v-card-text>
        </v-card>

        <v-card>
          <v-card-title>
            Datos de Contacto (Comercial)
          </v-card-title>
          <v-card-text>
            <v-text-field
              label="Nombre"
              id="contact_name"
              v-model="object.contact_name"
              :disabled="!editing"
            ></v-text-field>
            <v-text-field
              label="email"
              id="contact_email"
              v-model="object.contact_email"
              :disabled="!editing"
              @input="
                v => {
                  object.contact_email = v.toLowerCase();
                }
              "
            ></v-text-field>
            <v-text-field
              label="Teléfono"
              id="contact_phone"
              v-model="object.contact_phone"
              :disabled="!editing"
              type="number"
            ></v-text-field>
          </v-card-text>
        </v-card>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-card-text>

    <!-- commercial assigned list -->
    <v-card-text v-if="currentTab === 2 && object">
      <v-card>
        <v-card-title>
          <v-btn
            icon
            outlined
            color="primary"
            class="mr-3"
            @click="addCommercial"
            v-show="editing"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list two-line>
            <template v-for="(commercial, index) in object.commercials_data">
              <v-list-item :key="commercial.id">
                <template>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="commercial.person_name"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      class="text--primary"
                      v-text="commercial.commercial_person_type_description"
                    ></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action v-show="editing">
                    <v-icon @click="deleteCommercial(commercial)">
                      mdi-trash-can-outline
                    </v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>

              <v-divider
                v-if="index < commercial.length - 1"
                :key="index"
              ></v-divider>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-card-text>

    <!-- component for magnify searchs -->
    <paginated-search-dialog
      v-if="showSuperior || showCommercial"
      :show="showSuperior || showCommercial"
      :title="searchOptions.title"
      :endpoint="searchOptions.endpoint"
      :ordering="searchOptions.ordeting"
      :searchLabel="searchOptions.searchLabel"
      :headers="searchOptions.headers"
      :filterString="searchOptions.filterstring"
      :canEdit="false"
      :canAdd="false"
      @itemSelected="searchSelected($event)"
      @cancel="searchCanceled"
    >
    </paginated-search-dialog>
  </v-card>
</template>
<script>
import Person from "@/components/Person.vue";
import PaginatedSearchDialog from "@/components/PaginatedSearchDialog.vue";

export default {
  name: "ProducerEdit",

  components: {
    Person,
    PaginatedSearchDialog
  },

  props: ["value", "initialmode"],

  data: () => ({
    currentTab: 0,
    editing: false,
    mode: null,
    object: null,
    categories: null,
    showSuperior: false,
    showCommercial: false,
    searchOptions: {}
  }),

  methods: {
    async personSelected(person) {
      try {
        if (!person.identification_type_code) {
          person = await this.$bRoot.getObjectByURL(person.url);
        }
        //tryNew
        let response = await this.$bRoot.search(
          this.$bRoot.auth.current_level <= 2
            ? "/data/producers"
            : "/data/producers_hierarchy",
          null,
          null,
          this.$bRoot.auth.current_level <= 2
            ? "person__identification_type__code=" +
                person.identification_type_code +
                "&person__identification=" +
                person.identification
            : "identification_type_code=" +
                person.identification_type_code +
                "&identification=" +
                person.identification
        );
        if (response.data.results.length > 0) {
          // producer exists and user can edited it
          this.mode = "edit";
          this.currentTab = 1;
          this.beginEdit(
            response.data.results[0].producer
              ? response.data.results[0].producer
              : response.data.results[0].url
          );
        } else {
          response = await this.$bRoot.search(
            "/data/producers",
            null,
            null,
            "person__identification_type__code=" +
              person.identification_type_code +
              "&person__identification=" +
              person.identification
          );
          if (response.data.results.length > 0) {
            // producer exists and user can't edited = error
            throw "El registro ya existe";
          } else {
            // new producer
            this.mode = "new";
            this.initialize(person);
            this.currentTab = 1;
          }
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
        this.$emit("endEdit");
      }
    },

    async beginEdit(producer_url) {
      try {
        this.$bRoot.errors = null;
        if (producer_url) {
          this.object = await this.$bRoot.getObjectByURL(producer_url);
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError("Error recuperando datos de Productor");
        }
      }
    },

    initialize(person) {
      this.object = {
        url: null,
        person: person.url,
        person_identification_type_code: person.identification_type_code,
        // eslint-disable-next-line
        person_identification_type_description: person.identification_type_description,
        person_identification: person.identification,
        person_name: person.name,
        category: null,
        category_id: null,
        category_description: null,
        superior: null,
        superior_person_name: null,
        superior_person_identification: null,
        superior_person_identification_type_code: null,
        contact_name: null,
        contact_email: null,
        contact_phone: null,
        commercials_data: [],
        commercial_persons: [],
        commercial_person_ids: []
      };
    },

    superiorClick() {
      if (this.object.superior) {
        //remuve superior
        this.object.superior_person_name = null;
        this.object.superior_person_identification = null;
        this.object.superior_person_identification_type_code = null;
        this.object.superior = null;
      } else {
        //add superior
        this.searchOptions = {
          headers: [
            { text: "Nombre", value: "name", sortable: false },
            { text: "CUIT", value: "identification", sortable: false },
            { text: "Tipo", value: "category_description", sortable: false }
          ],
          title: "Informar Agrupado En...",
          endpoint: "/data/producers",
          ordering: "name",
          searchLabel: "Nombre/CUIT",
          filterString: null
        };
        this.showSuperior = true;
      }
    },

    searchSelected(data) {
      if (this.showSuperior) {
        this.superiorSelected(data);
      } else if (this.showCommercial) {
        this.commercialSelected(data);
      }
    },

    superiorSelected(data) {
      this.showSuperior = false;
      this.searchOptions = {};
      if (data.id === this.object.id) {
        this.$bRoot.setError("Agrupado en no puede ser el propio productor");
      } else {
        this.object.superior_person_name = data.name;
        this.object.superior_person_identification = data.identification;
        this.object.superior_person_identification_type_code =
          data.identification_type_code;
        this.object.superior = data.url;
      }
    },

    searchCanceled() {
      this.showSuperior = false;
      this.showCommercial = false;
      this.searchOptions = {};
    },

    async deleteCommercial(item) {
      let resp = await this.$confirm(
        "Confirme que desea remover el comercial " +
          item.person_name +
          " del productor  " +
          this.object.person_name
      );
      if (resp) {
        let index = this.object.commercials_data.findIndex(
          commercial => commercial.url === item.url
        );
        this.object.commercials_data.splice(index, 1);
        this.object.commercial_person_ids.splice(index, 1);
        this.object.commercial_persons.splice(index, 1);
      }
    },

    addCommercial() {
      //add superior
      this.searchOptions = {
        headers: [
          { text: "Nombre", value: "name", sortable: false },
          {
            text: "Tipo",
            value: "commercial_type_description",
            sortable: false
          }
        ],
        title: "Asignar Agente",
        endpoint: "data/commercial_persons_hierarchy",
        ordering: "name",
        searchLabel: "Nombre/CUIT",
        filterstring: "commercial_type_level=3&name__icontains="
      };
      this.showCommercial = true;
    },

    commercialSelected(data) {
      this.showCommercial = false;
      this.searchOptions = {};
      if (data) {
        // eslint-disable-next-line
        if (this.object.commercial_persons.findIndex(url => url === data.commercial_person) === -1) {
          this.object.commercials_data.push({
            url: data.commercial_person,
            person_name: data.name,
            commercial_person_type_description: data.commercial_type_description
          });
          this.object.commercial_person_ids.push(data.commercial_id);
          this.object.commercial_persons.push(data.commercial_person);
        }
      }
    },

    async save() {
      try {
        let args = this.object;
        //validate producer information
        if (this.$bRoot.isNullOrEmpty(args, "person")) {
          throw "El dato persona obligatorio";
        }
        if (this.$bRoot.isNullOrEmpty(args, "category")) {
          throw "El dato categoría obligatorio";
        }
        if (this.$bRoot.isNullOrEmpty(args, "contact_name")) {
          throw "El nombre del contacto es obligatorio";
        }
        if (this.$bRoot.isNullOrEmpty(args, "contact_email")) {
          throw "El email del contacto obligatorio";
        }
        if (this.$bRoot.isNullOrEmpty(args, "contact_phone")) {
          throw "El teléfono del contacto es obligatorio";
        }
        let object = {
          person: args.person,
          category: args.category,
          superior: args.superior,
          contact_name: args.contact_name,
          contact_email: args.contact_email,
          contact_phone: args.contact_phone,
          commercial_persons: args.commercial_persons,
          commercial_person_ids: args.commercial_person_ids
        };
        let current_level = this.$bRoot.auth.current_level;
        if (args.url) {
          object.url = args.url;
        }
        if (!object.url && current_level > 2) {
          if (current_level === 3) {
            object.commercial_persons.push(
              this.$bRoot.appInfo.commercial_person.url
            );
            object.commercial_person_ids.push(
              this.$bRoot.appInfo.commercial_person.id
            );
          } else if (current_level == 4) {
            object.commercial_persons.push(
              this.$bRoot.appInfo.commercial_person.superior
            );
            object.commercial_person_ids.push(
              this.$bRoot.appInfo.commercial_person.superior_id
            );
          }
        }
        let added = null;
        if (object.url) {
          added = await this.$bRoot.save(object);
        } else {
          added = await this.$bRoot.add(
            "/data/producers",
            "person__identification_type__code=" +
              args.person_identification_type_code +
              "&person__identification=" +
              args.person_identification,
            object
          );
        }
        if (added) {
          this.$emit("endEdit");
        } else if (!this.$bRoot.errors) {
          this.$bRoot.setError("El registro no se guardo");
        }
      } catch (error) {
        if (!this.$bRoot.Errors) {
          this.$bRoot.setError(error);
        }
      }
    }
  },

  mounted() {
    this.enableLeaders = this.$bRoot.auth.current_level <= 2;
    this.currentTab = this.value ? 1 : 0;
    this.mode = this.initialmode;

    if (!this.categories) {
      // eslint-disable-next-line
      this.$bRoot.search("/data/categories", null, 'description', 'applies_to_producers=true')
        .then(response => {
          if (response["data"]) {
            this.categories = response.data.results;
            this.beginEdit(this.value);
            this.editing = this.mode === "edit" || this.mode == "new";
          }
        })
        .catch(() => {
          this.mode = "show";
          this.editing = false;
        });
    }
  }
};
</script>
<style scoped>
.enabled-icon {
  pointer-events: auto;
  color: black;
}
.disbled-icon {
  pointer-events: none;
}
</style>
